<template>
  <div>
    <div class="p-3 pt-1 bg-white bb-1">
      <h6>MESSAGES
        <img v-if='canCreateGroup' @click='emitNewGroup()' class='icon pull-right' src="static/assets/img/SVGIcons/icon-plus-blue.svg" />
      </h6>
    </div>
    <div class="max-height-container scroll-y">
      <ul class="list-group list-group-flush">
        <li class="list-group-item p-0" @click='clickGroup(group)' v-for='group in groups' :key='group.GroupId' v-bind:class="{ 'selected' : isSelected(group)}">
          <table class="table layout-one">
            <tbody>
              <tr class="">
                <td class="avatar-container">
                  <img :src="lastSenderPic(group)" v-if='lastSenderPic(group)'/>
                  <img v-if='!lastSenderPic(group)' src='static/assets/img/avatar.png' />
                </td>
                <td class="p-1">
                  <div class="d-flex">
                    <div class="px-1 mr-auto sender-name">
                      <b>{{group.GroupName}}</b>
                    </div>
                    <div class="px-1 timestamp text-right" v-if='group.MessageBadgeCount'>
                      <small class="badge">{{group.MessageBadgeCount}}</small>
                    </div>
                  </div>
                  <div class="d-flex">
                    <div class="px-1 mr-auto last-message">{{group.LastMessageText}} </div>
                    <div class="px-1 timestamp text-right">
                      <small>{{group.LastMessageDT | formatDate }}</small>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
  export default {
    // computed: {
    //   isSelectecd = group.
    // },
    methods: {
      clickGroup(group) {
        let vm = this;
        vm.$emit('clickgroup', group)
      },
      isSelected(group) {
        let vm = this;
        if (group.GroupId == vm.selectedGroupId)return true
        else return false

      },
      emitNewGroup() {
        let vm = this;
        vm.$emit('newgroup')
      },
      lastSenderPic(group){
        if(group.Messages && group.Messages.length > 0){
        let lastMsg = group.Messages[group.Messages.length -1]
        return lastMsg.SenderAvatarUrl
        }
        return '';
      }
    },
    filters: {
      formatDate: function (dateUTC) {
        if (!dateUTC) return "";

        var date = moment(dateUTC);

        if (!date.isValid()) return "";

        var currentTime = moment();

        var duration = moment.duration(currentTime.diff(date));

        //If today
        if (duration.asDays() < 1 && currentTime.date() === date.date())
          return date.format("hh:mm A");
        else if (duration.asDays() < 7) return date.format("dddd");
        else {
          if (date.year() === currentTime.year()) return date.format("MMM DD");
          else return date.format("MM/DD/YY");
        }
      }
    },
    props: ['groups', 'selectedGroupId', 'canCreateGroup'],
  }

</script>

<style lang='scss' scoped>
  .icon {
    height: 24px;
    width: auto;
  }

  .max-height-container {
    height: calc(100vh - 295px - 60px);
    position: relative;
    width: auto; // padding-bottom: 100px;
    .list-group-item .table {
      margin-bottom: 5px;

      td {
        border:0;
      }

    }
    .list-group-item.selected {
      background: $gray-lt;
    }
    #messages-container {
      height: 100%;
    }

    #composer-container {
      width: 100%;
      padding: 8px;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
    }



    .avatar-container {
      min-height: 45px;
      width: 45px;
      padding: 5px 10px 5px 10px ;

      img {
        border-radius: 50%;
        overflow: hidden;
        height: 45px;
        width: 45px;
      }
    }

    .sender-name {
      max-width: 217px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .last-message {
      max-height: 36px;
      overflow: hidden;
      font-size: 0.8rem;
      line-height: 1.4em;
    }

    .timestamp {
      min-width: 60px;
    }

    .badge {
      background: red;
      border-radius: 50%;
      padding: 3px 5px;
      color: white;
      font-size: 0.8em;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/GroupList/GroupList.vue